export const ProjectsWorkedOn = [
  {
    title: "Ticket Booking Application",
    madeWith: "ExpressJS, MongoDB, Angular, AWS",
    imageName: "movie-app.jpg",
    details:
      "An application which had three User Role." +
      "Theatre Owner - Allows the user to post their theatre details along with seating layout." +
      " ADMIN - Create theatre owner account and distributes the movie to every theatre owner" +
      " User - Can book the ticket and also manage the same",
    url: "https://github.com/triquetrx?tab=repositories&q=Movie-app",
  },
  {
    title: "Banking Application",
    madeWith: "Java, ReactJS, AWS",
    imageName: "banking.PNG",
    details:
      "An automation based banking application which was build with the help of Java, Spring boot and was hosted on AWS Fargate, this application was created in microservice based architecture and also had two user role ADMIN-Bank User, User - Account Holder",
    url: "https://github.com/triquetrx?tab=repositories&q=banking",
  },
  {
    title: "Service Management Portal",
    madeWith: "Java, ReactJS, AWS",
    imageName: "react-aws.png",
    details:
      "A simple website capable of providing service booking for a specific product, the whole application was different microservice communicating together.",
    url: "https://github.com/triquetrx?tab=repositories&q=sbm",
  },
  {
    title: "Task Manager",
    madeWith: "VueJs",
    imageName: "taskmanager.jpg",
    details:
      "A vue js based website with HTML & CSS with bootstrap,It allows user to create task and prioritize the same depending on the priority of the task points will be provided.",
    url: "https://github.com/triquetrx/task-manager",
  },
  {
    title: "Identity Generator",
    madeWith: "VueJs",
    imageName: "identity-generator.PNG",
    details:
      "A vue js based website which allows user to generate strong 12 characters password also it uses 'Random User API' to generate fake names, address, and email address.",
    url: "https://identity-generator.netlify.app/",
  },
  {
    title: "Discord Bot",
    madeWith: "Python",
    imageName: "discordBot.png",
    details:
      "A python discord bot which could respond to every message you send though it's still text based and not voice but it tells jokes, roast another member on the channel and more.",
    url: "https://bit.ly/3wszEuC",
  },
  {
    title: "Other Python Projects",
    madeWith: "Python",
    imageName: "pythonProjects.png",
    details:
      "One of my programming language is python, I created projects for the same few of them are Youtube to Spotify playlist sender using the two APIs of the same.",
    url: "https://github.com/triquetrx?tab=repositories&q=&type=&language=python&sort=",
  },
  {
    title: "Music Application",
    madeWith: "React Native",
    imageName: "react-native-app.png",
    details:
      " A simple front end music application based on react-native which allows to navigate between pages download new songs, Can also be considered as clone of spotify.",
    url: "https://triquetrx.blogspot.com/2021/07/automatic-disinfectant-spraying-machine.html",
  },
  {
    title: "Automatic Disinfectant Machine",
    madeWith: "Raspberry Pi",
    imageName: "disinfectantRobot.png",
    details:
      "A project which used an unmanned vehicle the data to which was provided by the IR sensor and the camera by which it determined the motion of its for camera openCV was used...",
    url: "https://triquetrx.blogspot.com/2021/07/automatic-disinfectant-spraying-machine.html",
  },
  {
    title: "Smart Glasses",
    madeWith: "C, Arduino",
    imageName: "smartGlasses.png",
    details:
      " An idea inspired from google glasses we tried making one using Arduino Nano and other such components, the device is capable of connecting to  the smart phone via Bluetooth using Bluetooth module and display incoming calls, notifications and time for the same.",
    url: "https://triquetrx.blogspot.com/2021/07/automatic-disinfectant-spraying-machine.html",
  },
];
